export default __webpack_public_path__ + "static/icon-9-5-9084a10ed9caa5d786533aebadba33a0.png";